import React from 'react';
import styled from 'styled-components';

import { PublicSessionLoginContinue } from 'src/assets/public-session-login-continue';
import { PublicSessionLoginSuccess } from 'src/assets/public-session-login-success';
import { ContentContainer, Title, Subtitle } from 'src/components/kiosk-pro/kiosk-pro-shared/kiosk-pro-shared.styles';

export function KioskLoginContinue({
  isUserLoggedInSuccessfully,
  userFirstName,
}: {
  isUserLoggedInSuccessfully: boolean;
  userFirstName: string;
}): JSX.Element {
  return (
    <ContentContainer>
      {isUserLoggedInSuccessfully ? (
        <>
          <PublicSessionLoginSuccess />
          <ContinueTitle>
            <span aria-hidden='true'>👋</span>
            &nbsp; Hi, {userFirstName}!
          </ContinueTitle>
        </>
      ) : (
        <>
          <PublicSessionLoginContinue />
          <ContinueTitle>Continue on your phone</ContinueTitle>
          <ContinueSubTitle>This screen will automatically refresh</ContinueSubTitle>
        </>
      )}
    </ContentContainer>
  );
}

const ContinueTitle = styled(Title)`
  margin-bottom: 0;
`;

const ContinueSubTitle = styled(Subtitle)`
  color: ${({ theme }) => theme.colors.grey[60]};
  font-weight: 500;
`;
